module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.97/js/sprocket_white.svg"